RivalIQ.apps.Dashboard.module('widgets.table', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.TableMetricChooser = Marionette.LayoutView.mixin({
        template: '#tableMetricChooserModal',

        regions: {
            metricsRegion: '.x-metrics-container'
        },

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        ui: {
            modal: '.modal',
            saveBtn: '.x-save'
        },

        events: {
            'click @ui.saveBtn': 'onSave',
            'shown.bs.modal': 'onModalShown'
        },

        // configuration for subclasses.
        metricsProp: 'tableMetrics',
        saveTrackingConfig: null,
        showProgressBar: false,

        getMetricsCollection: function () {
            const me = this;

            const metrics = me.dashboardModel.getProp(_.result(me, 'metricsProp'));

            return new RivalIQ.apps.Favorites.collections.Metrics(metrics, {
                parse: true,
                baseMetric: me.dashboardModel.baseMetric,
                source: me.getProp('source')
            });
        },

        getAdditionalMetrics: _.constant([]),

        onRender: function () {
            const me = this;

            me.metricsCollection = me.getMetricsCollection();

            const additionalMetrics = me.getAdditionalMetrics();
            const disableOptgroups = _.get(me, ['disableOptgroups'], true);

            me.metricsRegion.show(new RivalIQ.apps.Favorites.views.MetricsView({
                collection: me.metricsCollection,
                dashboardModel: me.dashboardModel,
                timeAnalysisMode: false,
                showProgressBar: me.showProgressBar,
                useEmptyMetricOnAdd: true,
                useFuzzyMetricFind: true,
                disableOptgroups: disableOptgroups,
                source: false,
                additionalMetrics: additionalMetrics
            }));
        },

        _getAttributesToSave: function () {
            const me = this;

            const metrics = me.metricsCollection.map(function (metricConfig) {
                return _.defaults({
                    showProgressBar: Boolean(metricConfig.get('showProgressBar'))
                }, metricConfig.get('metric'));
            });

            const attributesToSave = {};
            attributesToSave[_.result(me, 'metricsProp')] = metrics;

            return attributesToSave;
        },

        onSave: function () {
            const me = this;

            const hasIncompleteMetrics = me.metricsCollection.any(function (metricConfig) {
                return !_.get(metricConfig.get('metric'), 'property');
            });
            if (hasIncompleteMetrics) {
                return;
            }

            me.ui.saveBtn.button('loading');

            const attributesToSave = me._getAttributesToSave();
            const result = me.dashboardModel.save(attributesToSave);

            if (!result) {
                return me.ui.saveBtn.button('reset');
            }

            if (me.saveTrackingConfig) {
                RivalIQ.execute('tracking:push:auth', me.saveTrackingConfig, attributesToSave);
            }

            const wrap = (fn) => {
                if (me.isRendered && !me.isDestroyed) {
                    fn();
                }
            };

            result
                .done(function () {
                    wrap(() => me.ui.modal.modal('hide'));
                })
                .fail(function () {
                    RivalIQ.execute('alert:warning', 'An error occurred. Please try again');
                    wrap(() => me.ui.saveBtn.button('reset'));
                });
        }
    });
});
